import { useState } from "react";
import { ReactComponent as ArrowDown } from "../../../assets/elevva-pro-icons/arrowWhite-down.svg";
import { ReactComponent as ArrowUp } from "../../../assets/elevva-pro-icons/arrowWhite-up.svg";
import "../athlete-control.css";

const CollapsibleItem = ({ item, control }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className="d-flex flex-column align-items-center justify-content-between  w-100"
      style={control ? {} : { maxWidth: "30rem", minWidth: "30rem" }}
    >
      <div className="w-100">
        <button
          onClick={() => setIsOpen(!isOpen)}
          style={{
            background: "#3177BE",
            color: "white",
            border: "none",
            borderRadius: "20px",
            padding: "0.5rem 1rem",
          }}
          className="d-flex w-100 justify-content-between align-items-center gap-3 my-1 label-step-control"
        >
          {item.name}
          {isOpen ? <ArrowDown /> : <ArrowUp />}
        </button>
      </div>
      {isOpen && <div className="w-100">{item.value}</div>}
    </div>
  );
};

export default CollapsibleItem;
